module.exports = __webpack_public_path__ + "static/media/arrow_down.1e55f07a.svg";